import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar';
import Hero from '../../components/hero';
import About from '../../components/about';
import Practice2 from '../../components/PracticeS2';
import Testimonial from '../../components/Testimonial';
import Consultinencey from '../../components/Consultinencey';
import BlogSection from '../../components/BlogSection';
import BoletinSection from '../../components/BoletinSection';
import Footer from '../../components/footer';
import Scrollbar from '../../components/scrollbar';
import CalFloatingButton from '../../components/CalFloatingButton';
import Logo from '../../images/logo.svg';
import Slider from '../../components/extra';
import SEO from '../../SEO';
import { getRouteMeta } from '../../seo/routes';

const HomePage3 = () => {
  return (
    <Fragment>
      <SEO {...getRouteMeta('/')} />
      <Navbar
        hclass={'wpo-header-style-2'}
        Logo={Logo}
        topbarNone={'header-without-topbar'}
      />
      <Hero heroClass={'wpo-hero-slider-s2'} />
      <About />
      <Slider />
      <Practice2 />
      <Testimonial />
      <BlogSection />
      <BoletinSection />
      <Consultinencey />
      <Footer />
      <Scrollbar />
      <CalFloatingButton />
    </Fragment>
  );
};
export default HomePage3;
